<template>
    <div>
        <card>
            <el-table :data="ApiData" style="width: 100%;" v-if="canEdit" ref="table">

                <el-table-column 
                    type="expand" 
                    width="120"
                    resizable
                    sortable>
                    <template v-slot="scope">
                        Тут редактор будет жить. специально оборудуем ему подвал и поселим
                        <ReFormPrinter
                            :masFormConfig="getForm(scope.row)"
                            :SuccessGo="(p,d)=>{SuccessGo(p,d,scope.row); closeRow(scope.row)}" 
                            :CancelGo="(p,d)=>{CancelGo(p,d); closeRow(scope.row)}"
                            :objSaveApiMethod="{apiParam:{obj:'marketing_sites_terms',flt:{id:scope.row.siteTermId,siteId:scope.row.siteId},uData:{}},apiMethod:'HELP_UPD'}"
                            
                        />
                    </template>
                </el-table-column>

                
                <el-table-column
                    label="ID"
                    property="siteTermId"
                    width="80"
                >
                </el-table-column>
                <!-- <el-table-column
                    label="default"
                    property="default"
                    width="80"
                >
                </el-table-column> -->
                <el-table-column 
                    min-width="180"
                    label="Тип"
                    property="name"
                >
                </el-table-column>
                <el-table-column 
                    min-width="180"
                    label="Зипал"
                    property="type"
                >
                </el-table-column>
                <el-table-column 
                    min-width="180"
                    label="Локальный"
                    property="type_local"
                >
                </el-table-column>
            </el-table>
        </card>

    </div>
</template>

<script>
import { Table, TableColumn, Select, Option, Tooltip, Button } from 'element-ui';
import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";

export default {
	name: 'MarketingSitesEditor',
	components: {
        [Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,  
        ReFormPrinter,      
	},
	props: {
	},
	data() {
		return {
			ApiData: [],
            forms:{},
		};
	},
	computed: {
		canEdit(){
			if(this.$GVO.my_profile.adm == 1 || this.$GVO.my_profile.AdsMaster == 1) {
				return true;
			} return false;
		}        
	},
	methods: {
        getForm(row){
            // Сделано кеширование форм. т.к. иначе загрузка кратинки вызывает перерисовку компонента, а он запрашивает новую форму, а данных по картинке нет.
            if(!this.forms[row.siteTermId]){
                this.forms[row.siteTermId]=[{
                    blockTitle:"Основное",
                    elements:[{
                        acceptMime: '*/*',
                        bShowTrash: true,
                        elementGetParamMap: 'photo',
                        elementType: 'image-upload',
                        element_model: row.photo>''? JSON.parse(row.photo): [],
                        src_filenames: [],
                        label: 'Картинка',
                        multiple: false,
                        placeholder: 'Примерный вид объекта на площадке с данным продвижением',
                        required: false,
                        type:'file',
                        uploadApi: {
                            apiMethod:'UniUpload',
                            apiParam:{
                                flt:{
                                    type: 'site_term'
                                },
                                obj: 'FileUpload',
                            }
                        }
                    },{
                        elementGetParamMap:'description',
                        elementType:'textarea',
                        element_model: row.description||'',
                        label: 'Описание продвижения',
                        placeholder: 'Опишите что даёт продвижение и на что влияет на площадке',
                        required:false,
                    }],
                }];
            }
            // console.log(row);
            return this.forms[row.siteTermId];
        },
        closeRow(row){
            this.$refs.table.toggleRowExpansion(row, false); // Закрыть строку

        },
        SuccessGo(path,data,row){
            if(data.data){
                for(let k in data.data){
                    if(Object.prototype.hasOwnProperty.call(row,k))
                        row[k] = data.data[k];
                }
            }
            // console.log('success',arguments);
        },
        CancelGo(path,data){
            // console.log('cancel',data);
        },
		getApiSites(){
			this.$GVO.ApiCall('marketing_sites.GET',{flt:{'act':1, terms:true,id:this.$route.params.site_id}})
			.then((objApi) => {
				// this.ApiSitesTable = [];
				if(objApi.success === true){
					if(objApi.data.length > 0){
                        this.SiteInfo = objApi.data[0];
						this.ApiData = objApi.data[0].mst_data;
						// if(objApi.total!=undefined) { this.masObjectsNew_total=objApi.total; }
					}else{
						this.ApiData=[];
                        this.SiteInfo={};
					}
				}
			}).catch(errorObjApi => {console.error(errorObjApi); this.ApiData = [];});
		},				

	},		
	mounted() {
		this.getApiSites();
	}
};
</script>